import styled from 'styled-components';
import { IClientItem } from '../../containers/SmsPanel/SmsPanel';
import { black, orange, red } from '../../utils/style/colors';

type IListItems = IClientItem;

interface ICustomSidebarProps {
  menuHeader?: React.ReactNode;
  height: string;
  width: string;
  sidebarListItems: Array<IListItems>;
  onChangeItem: (item: IListItems) => void;
  children: React.ReactNode;
  selectedItem: IListItems | null;
}

export const ICustomSidebarContainer = styled.div`
  display: grid;
  height: ${(props) => props.customHeight};
  grid-template-columns: ${(props) => props.customWidth} 1fr;
  overflow: hidden;
`;

const Sidebar = styled.ul`
  margin: 0 1rem;
  overflow: auto;
  border-inline-end: 1px solid lightgrey;
`;

const SidebarItem = styled.li`
  padding: 0.5rem;
  margin-inline-end: 1.5rem;
  ${(props) => props.isSelected && 'background: lightgrey'}
  color: ${(props) => props.color};
  &:hover {
    cursor: pointer;
    background: lightgrey;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: auto;
`;

const CustomSidebar: React.FC<ICustomSidebarProps> = ({
  menuHeader,
  height,
  width,
  sidebarListItems,
  children,
  onChangeItem,
  selectedItem,
}) => {
  const handleSelectedItem = (item: IListItems) => {
    onChangeItem(item);
  };

  return (
    <ICustomSidebarContainer customHeight={height} customWidth={width}>
      <Sidebar>
        {menuHeader && (
          <h4
            className="font-bold"
            style={{
              borderBottom: '1px solid lightgrey',
              textAlign: 'center',
              padding: '0.5rem',
              marginInlineEnd: '1.5rem',
            }}
          >
            {menuHeader}
          </h4>
        )}
        {sidebarListItems.map((item) => (
          <SidebarItem
            key={item.id}
            onClick={() => handleSelectedItem(item)}
            isSelected={selectedItem ? item.id === selectedItem.id : false}
            color={
              item.balanceIRR < 10000
                ? item.balanceCheck
                  ? red
                  : orange
                : black
            }
          >
            {item.title || item.name}
          </SidebarItem>
        ))}
      </Sidebar>
      <Content>{children}</Content>
    </ICustomSidebarContainer>
  );
};

export default CustomSidebar;
